import React, { useEffect, useState } from "react";
import "./comentariosResponse.css";
import ComentariosForm from "./ComentariosForm";
import { useTranslation } from "react-i18next";
import avatar_user from "../../../assets/imgs/detalle_blog/avatar-user2.png";
import avatar_rbs from "../../../assets/imgs/detalle_blog/avatar-rbs2.png";
import img_prueba1 from "../../../assets/imgs/detalle_blog/blancasprueba1-cropped.svg";
import img_prueba2 from "../../../assets/imgs/detalle_blog/blancasprueba2-cropped.svg";
import img_prueba3 from "../../../assets/imgs/detalle_blog/Negrasprueba1-cropped.svg";
import img_prueba4 from "../../../assets/imgs/detalle_blog/Negrasprueba2-cropped.svg";
import triangleB from "../../../assets/imgs/detalle_blog/trianguloblanco.svg";
import triangleN from "../../../assets/imgs/detalle_blog/triangulonegro.svg";
import flechaizq from "../../../assets/imgs/detalle_blog/flecha_izq.png";
import flechader from "../../../assets/imgs/detalle_blog/flecha_der.png";
import axios from "axios";

const ComentariosResponse = ({ friendlyTag, guid, titulo }) => {
    const [t, i18n] = useTranslation("detail_blog");
    const [comentarios, setComentarios] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [activeIndex, setActiveIndex] = useState(1);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 800);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 800);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        const fetchComentarios = async () => {
            try {
                const response = await axios.get(`https://www.ricardosalinas.com/S8JFmpfeLW5iUVROXz2owTPU/api/comments/byfriendlyresponse/${friendlyTag}?offset=0&limit=1000`);
                setComentarios(response.data);
            } catch (error) {
                console.error("Error fetching comentarios: ", error);
            }
        };

        fetchComentarios();
    }, [friendlyTag]);

    const handlePrevClick = () => {
        if (isMobile) {
            if (currentIndex > 0) {
                setCurrentIndex(currentIndex - 1);
            }
        } else {
            if (currentIndex > 2) {
                setCurrentIndex(currentIndex - 3);
            }
        }


    };

    const handleNextClick = () => {
        if (isMobile) {
            if (currentIndex < comentarios.length - 1) {
                setCurrentIndex(currentIndex + 1);
            }
        } else {
            if (currentIndex < comentarios.length - 3) {
                setCurrentIndex(currentIndex + 3);
            }
        }
    };

    const formatDate = (date) => {
        const options = { day: "numeric", month: "long", year: "numeric" };
        return new Date(date).toLocaleDateString(i18n.language, options);
    };

    // Funciones y lógica para el paginado móvil
    const getPaginationNumbers = () => {
        const maxVisiblePages = 5;
        const totalPages = comentarios.length;
        let startPage = Math.max(1, currentIndex - 1);
        let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

        if (endPage - startPage + 1 < maxVisiblePages) {
            startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }

        return Array.from({ length: endPage - startPage + 1 }, (_, idx) => startPage + idx);
    };

    const handlePageClick = (index) => {
        setCurrentIndex(index - 1);
    };

    // Slider para Escritorio
    const renderDesktopSlider = () => (
        <div className="slider">
            {currentIndex > 0 && (
                <button className="slider-arrow left" onClick={handlePrevClick}>
                    <img src={flechaizq} alt="Avatar" className="flecha_pag" />
                </button>
            )}
            <div className="slider-content">
                {comentarios.slice(currentIndex, currentIndex + 3).map((comentario, index) => (
                    <div
                        key={index}
                        className={`div-resp-e ${index === activeIndex ? "activo" : ""}`}
                        onMouseEnter={() => setActiveIndex(index)}
                    >
                        <div className="div-comentario">
                            <div className="div-avatar">
                                <img src={avatar_user} alt="Avatar" className="avatar" />
                            </div>
                            <img src={triangleB} alt="Avatar" className="trianguloB" />
                            <div className="card comentario-card">
                                <div className="card-header">
                                    <div>
                                        <p className="card-author"><strong>{comentario.nombre}</strong></p>
                                        <p className="card-date">{comentario.procedencia}, {formatDate(comentario.fecha)}</p>
                                    </div>
                                </div>
                                <div className="div-linea">
                                    <img src={img_prueba1} alt="Avatar" className="quote-img-izq" />
                                    <hr className="linea_blanca"></hr>
                                </div>
                                <p className="card-body coment-user">{comentario.comentario}</p>
                                <div className="div-linea">
                                    <hr className="linea_blanca2"></hr>
                                    <img src={img_prueba2} alt="Avatar" className="quote-img-der" />
                                </div>
                            </div>
                        </div>
                        {comentario.titulo && comentario.respuesta && (
                            <div className="div-respuesta">
                                <div className="card respuesta-card">
                                    <div className="div-linea">
                                        <img src={img_prueba3} alt="Avatar" className="quote-img-izq2" />
                                        <p className="card-title card-title-rbs"><strong>{comentario.titulo}</strong></p>
                                        <hr className="linea_negra"></hr>
                                    </div>
                                    <p className="card-body coment-rbs">{comentario.respuesta}</p>
                                    <div className="div-linea">
                                        <hr className="linea_negra2"></hr>
                                        <img src={img_prueba4} alt="Avatar" className="quote-img-der2" />
                                    </div>
                                </div>
                                <img src={triangleN} alt="Avatar" className="trianguloN" />
                                <div className="div-rbs">
                                    <img src={avatar_rbs} alt="Avatar" className="avatar" />
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
            {currentIndex < comentarios.length - 3 && (
                <button className="slider-arrow right" onClick={handleNextClick}>
                    <img src={flechader} alt="Avatar" className="flecha_pag" />
                </button>
            )}
        </div>
    );

    // Slider para Móvil
    const renderMobileSlider = () => (
        <div className="slider-mobile">

            <div className="slider-content">
                {comentarios.slice(currentIndex, currentIndex + 1).map((comentario, index) => (
                    <div key={index} className="div-resp-e">
                        <div className="div-comentario">
                            <div className="div-avatar">
                                <img src={avatar_user} alt="Avatar" className="avatar" />
                            </div>
                            <img src={triangleB} alt="Avatar" className="trianguloB" />
                            <div className="card comentario-card">

                                <div className="div-linea">
                                    <img src={img_prueba1} alt="Avatar" className="quote-img-izq" />
                                    <div className="head-d-as">
                                        <p className="card-author"><strong>{comentario.nombre}</strong></p>
                                        <p className="card-date">{comentario.procedencia}, {formatDate(comentario.fecha)}</p>
                                    </div>
                                    <hr className="linea_blanca"></hr>
                                </div>
                                <p className="card-body coment-user">{comentario.comentario}</p>
                                <div className="div-linea">
                                    <hr className="linea_blanca2"></hr>
                                    <img src={img_prueba2} alt="Avatar" className="quote-img-der" />
                                </div>
                            </div>
                        </div>
                        {comentario.titulo && comentario.respuesta && (
                            <div className="div-respuesta">
                                <div className="card respuesta-card">
                                    <div className="div-linea">
                                        <img src={img_prueba3} alt="Avatar" className="quote-img-izq2" />
                                        <p className="card-title card-title-rbs"><strong>{comentario.titulo}</strong></p>
                                        <hr className="linea_negra"></hr>
                                    </div>
                                    <p className="card-body coment-rbs">{comentario.respuesta}</p>
                                    <div className="div-linea">
                                        <hr className="linea_negra2"></hr>
                                        <img src={img_prueba4} alt="Avatar" className="quote-img-der2" />
                                    </div>
                                </div>
                                <img src={triangleN} alt="Avatar" className="trianguloN" />
                                <div className="div-rbs">
                                    <img src={avatar_rbs} alt="Avatar" className="avatar" />
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>

            <div className="pagination">
                {currentIndex > 0 && (
                    <button className="slider-arrow left" onClick={handlePrevClick}>
                        <img src={flechaizq} alt="Avatar" className="flecha_pag" />
                    </button>
                )}
                {getPaginationNumbers().map((number) => (
                    <button
                        key={number}
                        className={`pagination-number ${number === currentIndex + 1 ? "active" : ""}`}
                        onClick={() => handlePageClick(number)}
                    >
                        {number}
                    </button>
                ))}
                {currentIndex < comentarios.length - 1 && (
                    <button className="slider-arrow right" onClick={handleNextClick}>
                        <img src={flechader} alt="Avatar" className="flecha_pag" />
                    </button>
                )}
            </div>
        </div>
    );

    return (
        <div className="DB_comentarios">
            <ComentariosForm guid={guid} friendly={titulo} />
            {comentarios && comentarios.length > 0 ? (
                <>
                    <div className="div-line-am">
                        <p>{isMobile ? (currentIndex+(comentarios.slice(currentIndex, currentIndex + 1)).length) :(currentIndex+(comentarios.slice(currentIndex, currentIndex + 3)).length)}/{comentarios.length} {(t('comments.v_comentarios'))}</p>
                        <hr className="line-am"></hr>
                    </div>
                    {isMobile ? renderMobileSlider() : renderDesktopSlider()}
                </>
            ) : (
                <div className="espacio-blk-pr"></div> // Contenido alternativo si no hay comentarios
            )}
        </div>
    );
};

export default ComentariosResponse;